import React from "react";
import blogdetailimage from "../../assets/blogdetail.png";
import profilelogo from "../../assets/profilelogo.png";
import post1 from "../../assets/postpic.png";
import post2 from "../../assets/postpic2.png";
import post3 from "../../assets/postpic3.png";
import './styles.css'
import { CgProfile } from "react-icons/cg";
import { FaSearch } from "react-icons/fa";
import { CiSearch } from "react-icons/ci";
const BlogDetailsPage = ({ blog }) => {
  console.log("🚀 ~ BlogDetailsPage ~ blog:", blog);
  const sanitizedContent = blog.content.replace(/<\/?p>/g, "");
  return (
    <div className="min-h-screen ">
      {/* Header */}
      <div className="w-full h-[146px] bg-[#C97C2A] flex justify-center items-center text-center text-white">
        <h1 className="font-bold text-[40px] sm:text-[60px] body">Blog</h1>
      </div>

      {/* Main content section */}
      <main className="max-w-7xl mx-auto py-8 px-6 md:flex flex-col md:flex-row md:gap-5">
        {/* Left Column: Blog Content */}
        <div className="lg:w-2/3 space-y-6 flex-[1.5]">
          <article className="bg-white p-6 rounded-lg shadow-md">
            <h2 className="text-3xl  body font-bold text-gray-900 mb-4">
              {blog.title}
            </h2>
            <div className="flex gap-4 items-center mb-5">
              <div className="flex items-center gap-2">
                <img src={profilelogo} className=" w-[28px] h-[28px] " alt="" />
                <h1 className=" text-[#696A75] md:text-[14px] body ">admin</h1>
              </div>
              <p className="text-[#696A75] body text-[14px] ">
                {new Date(blog.publishedAt).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </p>
            </div>
            <img
              className="w-full h-96 object-cover rounded-lg mb-6"
              src={blog.image || blogdetailimage}
              alt="Blog Post"
            />
            <p className="text-gray-700 body lg:text-lg md:text-[12px] text-[10px] mb-4">
              <div className="quill-content" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
            </p>
            
           
          </article>
        </div>

        {/* Right Column: Sidebar */}
        {/* <div className="md:w-1/3 w-[95%] mx-auto lg:pl-12 flex-1 mt-6 md:mt-0">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold body text-center text-gray-900 mb-4">
              Popular Posts
            </h3>
            <div className="flex flex-col gap-4">
  {[
    {
      img: post1,
      category: "DESIGN PROCESS",
      title: "Our 15 Favourite website from August",
      titleColor: "#111210",
    },
    {
      img: post2,
      category: "INSPIRATION",
      title: "The beginner's guide to user research",
      titleColor: "#C97C2A",
    },
    {
      img: post3,
      category: "INSPIRATION",
      title: "Website anatomy every designer should know",
      titleColor: "#111210",
    },
  ].map((post, index) => (
    <div
      key={index}
      className="flex items-center justify-start gap-4 p-4 "
    >
      <img
        src={post.img}
        alt=""
        className="w-16 h-16 object-cover rounded-md"
      />
      <div className="flex flex-col gap-2">
        <h1 className="text-[#9B9B9B] text-[13px] lg:text-[16px] md:text-[12px]">
          {post.category}
        </h1>
        <h1
          className={`text-[13px] lg:text-[16px] md:text-[12px] font-semibold`}
          style={{ color: post.titleColor }}
        >
          <span className="line-clamp-1">{post.title}</span>
        </h1>
      </div>
    </div>
  ))}
</div>

          </div>
          <div className="bg-white mt-6 rounded-lg shadow-md relative">
            <input
              type="text"
              className="p-6 w-full pr-12" // pr-12 adds padding on the right to make space for the icon
              placeholder="Type Something..."
            />
            <CiSearch className="absolute right-8 text-[1.5rem] top-1/2 transform -translate-y-1/2 text-gray-500" />
          </div>

          <div className="bg-white p-6 mt-6 rounded-lg shadow-md">
            <h3 className="text-xl font-semibold text-center text-gray-900 mb-4 body">
              Recent Posts
            </h3>
            <div className="flex flex-col gap-10">
              <div className="flex items-center  gap-3">
                <div className="flex flex-col gap-1">
                  <h1 className="text-[#9B9B9B] lg:text-[16px] md:text-[12px] text-[13px] body">DESIGN PROCESS</h1>
                  <h1 className="text-[#111210] lg:text-[16px] md:text-[10px] text-[13px] body font-semibold">
                    Our 15 Favourite website from Agust
                  </h1>
                </div>
              </div>
              <div className="flex items-center  gap-3">
                <div className="flex flex-col gap-1">
                  <h1 className="text-[#9B9B9B] lg:text-[16px] md:text-[12px] text-[13px] body">INSPIRATION</h1>
                  <h1 className="text-[#C97C2A] lg:text-[16px] md:text-[10px]  text-[13px] font-semibold body">
                    The beginners guide to user research
                  </h1>
                </div>
              </div>
              <div className="flex items-center  gap-3">
                <div className="flex flex-col gap-1">
                  <h1 className="text-[#9B9B9B] lg:text-[16px] md:text-[12px] text-[10px] body">INSPIRATION</h1>
                  <h1 className="text-[#111210] lg:text-[16px] md:text-[10px] text-[10px] body font-semibold">
                    Web page layout 101: website anatomy every designer
                  </h1>
                </div>
              </div>
              <div className="flex items-center  gap-3">
                <div className="flex flex-col gap-1">
                  <h1 className="text-[#9B9B9B] lg:text-[16px] md:text-[12px] text-[10px] body">FREELANCING</h1>
                  <h1 className="text-[#111210] lg:text-[16px] md:text-[10px]  body text-[10px] font-semibold">
                    10 essential sections to a high landing page
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </main>
    </div>
  );
};

export default BlogDetailsPage;
